import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useSupervisoresOutletContext } from 'pages/Supervisor'
import { useParams } from 'react-router-dom'
import { supervisor } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirSupervisor() {
    const { id } = useParams()
    const { data } = useSupervisoresOutletContext()
    const s = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = supervisor.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!s) return null

    const handleSubmit = () =>
        mutateAsync(s.id, {
            onSuccess: () => {
                toast.success('Supervisor excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'Supervisores'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o supervisor {s.nome}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
